import React from 'react';
import { modelClass, BuyTarget } from '/imports/api/buyTargets';
import { listCards, Card } from '/imports/api/cards';
import { ModelFormPage } from '/imports/ui/ModelFormPage';
import { RichSelect } from '/imports/ui/RichSelect';

const CardField = (
  setUpdate: (value: React.SetStateAction<Partial<BuyTarget>>) => void,
  update: Partial<BuyTarget>,
  document?: BuyTarget,
) => {
  const currentCardId = update.cardId ?? document?.cardId;
  const currentCard = update.card ?? document?.card;
  return (
    <RichSelect<Card>
      placeholder="Search cards by name…"
      listMethod={listCards}
      value={currentCardId !== undefined ? String(currentCardId) : undefined}
      preSelectedOption={
        currentCard && currentCardId !== undefined
          ? { value: String(currentCardId), label: `${currentCard}` }
          : undefined
      }
      mapToValue={(card) => ({
        value: String(card._id),
        label: card.setName ? `${card.name} (${card.setName})` : card.name,
        data: card,
      })}
      onChange={(option) => {
        const card = option.data as Card | undefined;
        setUpdate((prev) => ({
          ...prev,
          card: card?.name ?? option.label,
          cardId: Number(option.value),
        }));
      }}
    />
  );
};

export const BuyTargetPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [
      [{ field: 'card', label: 'Card', input: CardField }],
      [{ field: 'priority', label: 'Priority' }],
      [{ field: 'buycap', label: 'Buy Cap' }],
    ]}
  />
);
